/**
 * Calculates the current date with a timezone offset and returns it in ISO format
 * @returns {String}
 */ const getCurrentISOString = ()=>{
    const date = new Date();
    const isoDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
    return isoDateTime;
};
export default getCurrentISOString;
